<template>
  <div class="birthday-sex-page">
    <div class="content">
      <!-- Title -->
      <h1 class="title">Complete your profile</h1>
      <p class="subtitle">Help us personalize your experience</p>

      <!-- Birthday Section -->
      <div class="form-section">
        <label class="form-label">Birthday</label>
        <input 
          v-model="birthday" 
          type="date" 
          class="date-input"
          :max="maxDate"
        />
      </div>

      <!-- Sex Section -->
      <div class="form-section">
        <label class="form-label">Sex</label>
        <div class="sex-options">
          <button 
            class="sex-button"
            :class="{ active: sex === 'male' }"
            @click="sex = 'male'"
          >
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <circle cx="10" cy="14" r="6"/>
              <line x1="14.5" y1="9.5" x2="21" y2="3"/>
              <line x1="15" y1="3" x2="21" y2="3"/>
              <line x1="21" y1="3" x2="21" y2="9"/>
            </svg>
            <span>Male</span>
          </button>

          <button 
            class="sex-button"
            :class="{ active: sex === 'female' }"
            @click="sex = 'female'"
          >
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <circle cx="12" cy="8" r="6"/>
              <line x1="12" y1="14" x2="12" y2="21"/>
              <line x1="8" y1="18" x2="16" y2="18"/>
            </svg>
            <span>Female</span>
          </button>
        </div>
      </div>

      <!-- Next Button -->
      <button 
        class="next-button" 
        :disabled="!isFormValid"
        @click="handleNext(this)"
      >
        Next
      </button>
    </div>
    <AlertW type="info" ref="alertW"/>
    <Loader :loading="loading" />
  </div>
</template>

<script>
import AlertW from "@/views/components/alertW/AlertW.vue"
import Loader from "@/views/components/loader/Loader.vue"

export default {
  name: 'BirthdaySexPage',
  components: {
    AlertW,
    Loader
  },
  data() {
    return {
      birthday: '',
      sex: '',
      maxDate: '',
      loading:false
    }
  },
  computed: {
    isFormValid() {
      return this.birthday && this.sex;
    }
  },
  methods: {
    isAgeInvalid(birthDate) {
      if (!(birthDate instanceof Date) || isNaN(birthDate)) return true
      const today = new Date()
      let age = today.getFullYear() - birthDate.getFullYear()
      const hasHadBirthdayThisYear =
        today.getMonth() > birthDate.getMonth() ||
        (today.getMonth() === birthDate.getMonth() &&
        today.getDate() >= birthDate.getDate())

      if (!hasHadBirthdayThisYear) {
        age--
      }
      return age > 150 || age < 5
    },
    async handleNext (k) {
      if (this.isFormValid) {
        const [year, month, day] = k.birthday.split('-').map(Number)
        const date = new Date(year, month - 1, day)
        if(this.isAgeInvalid(date)) return this.$refs.alertW.show("Age invalide !")
        this.loading = true
        try {
            await k.$axios.post('/user.php',{type:"setSex",sex:k.sex == "male" ? "M" : "F"})
            await k.$axios.post('/user.php',{type:"setBirthDate",birthDate:date})
            const res = await k.$axios.post('/user.php',{type:"getUser",user:this.$route.params.uid})
            console.log('user we just go--',res.data)
            this.$store.commit('setUser',res.data)
            this.$store.commit('setUserProfile',res.data)

            this.loading = false
            this.$router.push("/profile/"+this.$route.params.uid)
        } catch (e) {
            console.log(e.response)
            this.loading = false
            //alert(e.response?.data?.error || e.message);
        }
      }
    }
  },
  mounted() {
    // clear pprevious data
    //localStorage.clear()
    // Set max date to today
    const today = new Date()
    this.maxDate = today.toISOString().split('T')[0]
    // save uid
    this.$store.commit('setUser',{uid:this.$route.params.uid,stats:{}})
    //------- before --------------------------
    if(this.$route.params.token != undefined) {
      this.$axios.setAccessToken(this.$route.params.token)
    }
    // necessary to activate notification dailyReminder
    this.$root.$refs.home.initNotification()
    if(this.$route.params.isUserExist == 1) {
      this.$router.push('/profile/'+this.$route.params.uid)
    }
  }
}
</script>

<style scoped>
.birthday-sex-page {
  position: absolute;
  left: 0px;
  top:0px;
  width: 100%;
  min-height: 100%;
  height: fit-content;
  overflow: auto;
  background: linear-gradient(135deg, rgb(10, 14, 38) 0%, rgb(26, 18, 48) 50%, rgb(13, 27, 42) 100%);
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  padding-bottom: 130px;
  z-index: 20000;
}

.content {
  width: 100%;
  max-width: 450px;
}

.title {
  color: #e0f7ff;
  font-size: 28px;
  font-weight: bold;
  text-align: center;
  margin: 0 0 12px 0;
  letter-spacing: 0.5px;
  text-shadow: 0 0 20px rgba(0, 212, 255, 0.5);
}

.subtitle {
  color: #94a3b8;
  font-size: 16px;
  text-align: center;
  margin: 0 0 40px 0;
}

.form-section {
  margin-bottom: 32px;
}

.form-label {
  display: block;
  color: #e0f7ff;
  font-size: 15px;
  font-weight: 600;
  margin-bottom: 12px;
  text-shadow: 0 0 10px rgba(0, 212, 255, 0.3);
}

.date-input {
  width: 100%;
  background: rgba(30, 41, 59, 0.8);
  border: 1px solid rgba(0, 212, 255, 0.2);
  color: #e0f7ff;
  font-size: 15px;
  padding: 14px 16px;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s;
  font-family: inherit;
}

.date-input:focus {
  outline: none;
  border-color: #00d4ff;
  box-shadow: 0 0 0 3px rgba(0, 212, 255, 0.1);
}

.date-input:hover {
  border-color: rgba(0, 212, 255, 0.5);
}

/* Style the date picker calendar icon */
.date-input::-webkit-calendar-picker-indicator {
  filter: invert(1);
  cursor: pointer;
}

.sex-options {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 12px;
}

.sex-button {
  background: rgba(30, 41, 59, 0.8);
  border: 1px solid rgba(0, 212, 255, 0.2);
  color: #e0f7ff;
  padding: 16px 12px;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  font-weight: 600;
}

.sex-button svg {
  width: 32px;
  height: 32px;
}

.sex-button:hover {
  border-color: rgba(0, 212, 255, 0.5);
  transform: translateY(-2px);
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.3);
}

.sex-button.active {
  background: rgba(0, 212, 255, 0.2);
  border-color: #00d4ff;
  color: #00d4ff;
  box-shadow: 0 0 20px rgba(0, 212, 255, 0.3);
}

.sex-button.active svg {
  filter: drop-shadow(0 0 8px rgba(0, 212, 255, 0.6));
}

.next-button {
  width: 100%;
  background: linear-gradient(135deg, #00d4ff, #0099cc);
  color: #ffffff;
  border: none;
  padding: 16px 24px;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s;
  box-shadow: 0 4px 15px rgba(0, 212, 255, 0.3);
  margin-top: 40px;
}

.next-button:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(0, 212, 255, 0.5);
}

.next-button:disabled {
  background: rgba(30, 41, 59, 0.6);
  color: #94a3b8;
  cursor: not-allowed;
  box-shadow: none;
}

@media (max-width: 480px) {
  .title {
    font-size: 24px;
  }

  .sex-options {
    grid-template-columns: 1fr;
  }
}
</style>